module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 30);
  /******/
}
/************************************************************************/

/******/
([
/* 0 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 2 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return getCurrentThemeName;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return useThemeSelector;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return ThemeProvider;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return ThemeContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return ThemeConsumer;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(25);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(42);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__global_styles__ = __webpack_require__(29);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__emotion_cache__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__emotion_react__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__emotion_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__emotion_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__stylis_plugin_extra_scope__ = __webpack_require__(31);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__stylis_plugin_extra_scope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__stylis_plugin_extra_scope__);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // import { ThemeProvider } from 'emotion-theming';


  var ThemeContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext();

  var ThemeConsumer = ThemeContext.Consumer;
  /**
   * Gel components normally receives the current theme in their 'theme' prop
   * However, getGelTokens() is not a Gel component but a utility function, which
   * needs access to the current theme name, in order to know from which theme
   * to get the tokens. Same with getGelIcons().
   * 
   * Therefore we store the current theme name here and provide the 
   * getCurrentThemeName() utility function for those that are not 
   * Gel components but still require access to the current theme name.
   * 
   * Each js file only executes once, and the exports will be cached for
   * reuse next time the same js file is imported. So at first execution,
   * currentTheme is initialised with getDefaultThemeName(), but later 
   * currentTheme can be assigned with new theme names in GelThemeProvider
   */
  // let currentTheme = getDefaultThemeName();
  // export const getCurrentThemeName = () => currentTheme;

  var currentTheme = null;

  var getCurrentThemeName = function getCurrentThemeName() {
    return currentTheme || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__themes__["c"
    /* getDefaultThemeName */
    ])();
  };
  /**
   * <GelThemeProvider theme={theme}>
   *  <GelButton primary medium>Test</GelButton>
   *  { getGelTokens().global.sizeBase }
   * </GelThemeProvider>
   * 
   * React makes all props (including the children prop) ready for GelThemeProvider
   * before rendering GelThemeProvider. So getGelTokens() will be invoked before
   * the rendering of GelThemeProvider, as the invokation of getGelTokens() is part of
   * the preparation of the children prop.
   * 
   * Therefore, when theme changes and triggers a re-render of the whole thing,
   * getGelTokens() will be invoked before the new `theme` is passed into GelThemeProvider.
   * getGelTokens() calls getCurrentThemeName() internally and will get the previous
   * theme (not the latest theme just changed to) as a result.
   * 
   * We want to force a re-render of the whole thing again after GelThemeProvider is re-rendered,
   * so that now getGelTokens() will get a chance to access the latest current theme name.
   * 
   * Look at another example:
   * 
   * <GelThemeProvider theme={theme}>
   *  { Object.entries(getGelIcons()).map(
   *     return <GelIcon name={key} width={30} />
   *  );}
   * </GelThemeProvider>
   * 
   * GelIcon invokes getGelIcons internally. The issue can be that when the outer getGelIcons
   * is invoked, `currentTheme` is still the previous theme; but when GelIcon gets to render, 
   * it actually gets the current theme internally, causing problems such as icon name picked up
   * from the previous theme does not exist in the current theme (when GelIcon renders)
   * 
   * This is because the invocation of the outer getGelIcons is part of the children prop 
   * preparation, before GelThemeProvider renders. After all props are prepared for 
   * GelThemeProvider, GelThemeProvider takes all props (including children), sets the 
   * `currentTheme`, renders itself and will also render its children (containing GelIcon). 
   * We can skip the outer getGelIcons invocation, by using GelIconIterator. 
   * 
   * Rendering a component:
   *  (1) Preparing/Evaluating props (including the children prop), to the point where
   *      there is nothing to be evaluated. However, the actual rendering of child 
   *      components will be part of the rendering of the parent component, and will 
   *      NOT occur before the parent component gets to render.
   *  (2) Rendering this parent component after prop preparations
   *  (3) If children are to be rendered, for each child component repeat (1) (2) (3)
   * 
   * NOTE!!
   * When it comes to the use of GelThemeProvider for single theme, if GelThemeProvider 
   * wraps <App> then probably code like <GelThemeProvider theme="il"> should work, as
   * there would be no need to access currentTheme prior to the rendering of GelThemeProvider.
   * 
   * However, if GelThemeProvider wraps for example getGelTokens directly, or if there are other 
   * places to access currentTheme before GelThemeProvider gets to render (and set the currentTheme) 
   * we need to add the following code:
   * 
   * useThemeSelector('il'); // This will be able set the currentTheme before GelThemeProvider does
   * 
   * before currentTheme needs to be accessed.
   */


  var useThemeSelector = function useThemeSelector(defaultTheme) {
    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useForceUpdate"])();

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(defaultTheme || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__themes__["c"
    /* getDefaultThemeName */
    ])()),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        theme = _useState2[0],
        setTheme = _useState2[1];

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useIsUnmounted"])();

    currentTheme = theme; // See `Note!!` in the comment above

    var selectTheme = function selectTheme(themeName) {
      var timer1 = setTimeout(function () {
        if (!isUnmountedRef.current) {
          setTheme(themeName);
        }

        clearTimeout(timer1);
      });
      var timer2 = setTimeout(function () {
        if (!isUnmountedRef.current) {
          forceUpdate();
        }

        clearTimeout(timer2);
      });
    };

    return [theme, selectTheme];
  };
  /**
   * React context to provide theme to all the library components
   * 
   * Note that `@tal-gel/theming` must be a peer dependency of other @tal-gel modules (See package.json),
   * and must not be bundled together with any of them (See webpack config)
   * 
   * This is to ensure that the client project and other @tal-gel modules use the same `ThemeContext`,
   * as `ThemeContext`s from different locations will have different keys, causing consumers not to be
   * able to find the matching provider
   * 
   * If from the same location, the `ThemeContext` returned from the first execution of this file 
   * will be cached and reused
   */


  var ThemeProvider = function ThemeProvider(_ref) {
    var _ref$global = _ref.global,
        global = _ref$global === void 0 ? true : _ref$global,
        _ref$resetCss = _ref.resetCss,
        resetCss = _ref$resetCss === void 0 ? false : _ref$resetCss,
        _ref$theme = _ref.theme,
        themeName = _ref$theme === void 0 ? getCurrentThemeName() : _ref$theme,
        _ref$targets = _ref.targets,
        targets = _ref$targets === void 0 ? [] : _ref$targets,
        _ref$backwardCompatib = _ref.backwardCompatible,
        backwardCompatible = _ref$backwardCompatib === void 0 ? [] : _ref$backwardCompatib,
        mode = _ref.mode,
        _ref$extraScope = _ref.extraScope,
        extraScope = _ref$extraScope === void 0 ? true : _ref$extraScope,
        removeScopeWrappers = _ref.removeScopeWrappers,
        children = _ref.children;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__themes__["b"
    /* getThemes */
    ])()[themeName]) {
      return null;
    }

    var getTheme = function getTheme(themeName) {
      return _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__themes__["b"
      /* getThemes */
      ])()[themeName]), backwardCompatible.reduce(function (result, value) {
        return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, "backwardCompatible".concat(value), true));
      }, {}));
    };

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(getTheme(themeName)),
        _useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        theme = _useState4[0],
        setTheme = _useState4[1];

    var initialLoad = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(true); // Store current theme name, see comments above 
    // about the currentTheme variable


    currentTheme = themeName;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // Skip the first run due to the default value in useState,
      // as even though theme name is the same, theme object is going
      // to be different (see getTheme). We skip the first run to avoid
      // unnecessary re-rendering. 
      if (!initialLoad.current) {
        setTheme(getTheme(themeName));
      }

      initialLoad.current = false;
    }, [themeName]);

    var isTestMode = function isTestMode() {
      return mode === 'test';
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, theme && (global ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeContext.Provider, {
      value: theme
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet__["a"
    /* Helmet */
    ], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    })), !removeScopeWrappers && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__global_styles__["a"
    /* default */
    ], {
      scoped: false
    }), !isTestMode() && extraScope ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__emotion_react__["CacheProvider"], {
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__emotion_cache__["a"
      /* default */
      ])({
        key: 'tal-gel',
        stylisPlugins: [// This plugin (unofficial yet) seems to be causing 
        // issues with tests that use `toHaveStyleRule`, 
        // so we do not apply this plugin if NODE_ENV is `test`
        __WEBPACK_IMPORTED_MODULE_9__stylis_plugin_extra_scope___default()('#tal-gel-level2'), __WEBPACK_IMPORTED_MODULE_9__stylis_plugin_extra_scope___default()('#tal-gel-level1')] // Increase specificity

      })
    }, !removeScopeWrappers ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      id: "tal-gel-level1"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      id: "tal-gel-level2"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__global_styles__["a"
    /* default */
    ], {
      scoped: true
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["GelAlertContextProvider"], null, children))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["GelAlertContextProvider"], null, children)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, !removeScopeWrappers && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__global_styles__["a"
    /* default */
    ], {
      scoped: true
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["GelAlertContextProvider"], null, children)) // not applying extra scope as not wrapped by CacheProvider
    ) :
    /*#__PURE__*/
    // This is for Angular wrappers
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ThemeContext.Provider, {
      value: getThemeByTargets({
        theme: theme,
        targets: targets
      })
    }, children)));
  };
  /**
   * This is for Angular wrappers
   */


  var getThemeByTargets = function getThemeByTargets(_ref2) {
    var theme = _ref2.theme,
        targets = _ref2.targets;
    return targets.reduce(function (result, target) {
      // performance
      return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, target, theme[target]));
    }, {});
  };
  /***/

},
/* 3 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return configureTheming;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return getThemes;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return getDefaultThemeName;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);

  var _excluded = ["key"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Variables in the closure, can be accessed by the exported functions.
   * 
   * When functions below are imported into Component A and then imported 
   * into Component B, JS will make sure that the same functions previously 
   * imported into A will be imported into B. As a result, the closure that 
   * the imported functions in A and B can access will be the same.
   */


  var themes;
  var defaultThemeName = 'tal';

  var configureTheming = function configureTheming() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$plugins = _ref.plugins,
        plugins = _ref$plugins === void 0 ? [] : _ref$plugins;

    if (plugins.length > 0) {
      defaultThemeName = plugins[0].key;
    }

    themes = plugins.reduce(function (themes, _ref2) {
      var key = _ref2.key,
          theme = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded);

      return _objectSpread(_objectSpread({}, themes), theme);
    }, {});
  };

  var getThemes = function getThemes() {
    if (!themes) {
      throw new Error('Theming not configured');
    }

    return themes;
  };

  var getDefaultThemeName = function getDefaultThemeName() {
    return defaultThemeName;
  };
  /***/

},
/* 4 */

/***/
function (module, exports) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("@emotion/react");
  /***/
},
/* 7 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(19);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__theme_provider__ = __webpack_require__(2); // TODO: make HOCs better such as supporting ref

  /**
   * HOC to inject theme to the GEL component
   */


  var withTheme = function withTheme(Component) {
    /**
     * React.memo is used here to prevent unnecessary re-renders 
     * (typically causing lags to the screen)
     * 
     * This is particularly important if the containing component with 
     * lots of GEL components (wrapped with `withTheme`) inside, has to render frequently
     */
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (props, forwardedRef) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__theme_provider__["e"
      /* ThemeConsumer */
      ], null, function (theme) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          theme: theme
        }, props, forwardedRef && {
          ref: forwardedRef
        }));
      });
    }));
  };
  /* harmony default export */


  __webpack_exports__["a"] = withTheme;
  /***/
},
/* 8 */

/***/
function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  var objectWithoutPropertiesLoose = __webpack_require__(24);

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  module.exports = _objectWithoutProperties;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(8);

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(44);
    } else {
      module.exports = __webpack_require__(43);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(0));
  /***/
},
/* 13 */

/***/
function (module, exports) {
  module.exports = require("@tal-gel/core");
  /***/
},
/* 14 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__theme_provider__ = __webpack_require__(2);
  /* harmony default export */


  __webpack_exports__["a"] = function () {
    var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // indicates whether it is brand icons or ui icons

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__themes__["b"
    /* getThemes */
    ])()["".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__theme_provider__["a"
    /* getCurrentThemeName */
    ])()).concat(!brand ? 'Ui' : 'Brand', "Icons")];
  };
  /***/

},
/* 15 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__theme_provider__ = __webpack_require__(2);
  /* harmony default export */


  __webpack_exports__["a"] = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__themes__["b"
    /* getThemes */
    ])()["".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__theme_provider__["a"
    /* getCurrentThemeName */
    ])(), "Tokens")];
  };
  /***/

},
/* 16 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return getStylesForStates;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return getFullState;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(26);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core__ = __webpack_require__(13);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__);

  var _excluded = ["Focus", "Active", "Hover", "Disabled", "Checked", "Danger", "Inverse"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Note that the inheritance/overriding we want to accomplish here is partially
   * supported by the browser (via the css specificity rules). We could choose to rely on
   * browser's support for part of the inheritance/overriding we want to build.
   * 
   * However, we have decided to build the full inheritance/overriding all in the `getStylesForStates`
   * function, so that we can apply a universal algorithm. The drawback is that each state will now
   * have its full style instead of just the different style compared to the normal state, in the actual
   * generated css.
   * 
   * Nevertheless, this universal algorithm accomplishes the inheritance/overriding among subtypes,
   * and also among different states inside each subtype. (See inheritance/overriding rules below)
   */

  /** 
   * Some components have 4 subtypes (Default, Danger, Inverse, InverseDanger)
   * and each subtype usually has 5 states (Normal, Focus, Active, Hover, Disabled)
   * (NOTE: Radiobox also has `Checked` state, and checkbox also has `Checked` and `Indeterminate` state)
   * 
   * For normal state ('<-' means overriding): 
   *   default <- danger
   *   default <- inverse
   *   default <- inverse <- inverse danger
   * 
   * For other states ('<-' means overriding): 
   *   default <- default[state] 
   *   default <- default[state] <- danger <- danger[state] 
   *   default <- default[state] <- inverse <- inverse[state]
   *   default <- default[state] <- inverse <- inverse[state] <- inverse danger <- inverse danger[state]
   */


  var getStylesForStates = function getStylesForStates(_ref) {
    var theme = _ref.theme,
        target = _ref.target,
        subTarget = _ref.subTarget,
        inverse = _ref.inverse,
        danger = _ref.danger,
        readOnly = _ref.readOnly,
        disabled = _ref.disabled,
        otherProps = _ref.otherProps,
        isFunc = _ref.isFunc,
        funcParams = _ref.funcParams;
    var targetStyle = !subTarget ? theme[target] : theme[target][subTarget];
    targetStyle = !isFunc ? targetStyle : targetStyle.apply(void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_toConsumableArray___default()(funcParams));

    if (otherProps && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["isFunction"])(targetStyle)) {
      // Some target can be a function to take props
      // and return styles based on props
      targetStyle = targetStyle(otherProps);
    }

    var getStyleByState = function getStyleByState(state) {
      var _targetStyle = targetStyle,
          Focus = _targetStyle.Focus,
          Active = _targetStyle.Active,
          Hover = _targetStyle.Hover,
          Disabled = _targetStyle.Disabled,
          Checked = _targetStyle.Checked,
          Danger = _targetStyle.Danger,
          Inverse = _targetStyle.Inverse,
          normalStyle = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_targetStyle, _excluded); // All default to the style of the normal state of default subtype


      var style = normalStyle;

      if (state && targetStyle[state]) {
        style = _objectSpread(_objectSpread({}, style), targetStyle[state]);
      }

      if (danger && !inverse) {
        // danger subtype
        if (targetStyle.Danger) {
          style = _objectSpread(_objectSpread({}, style), targetStyle.Danger);

          if (state && targetStyle.Danger[state]) {
            style = _objectSpread(_objectSpread({}, style), targetStyle.Danger[state]);
          }
        }
      } else if (inverse) {
        if (targetStyle.Inverse) {
          // inverse subtype
          style = _objectSpread(_objectSpread({}, style), targetStyle.Inverse);

          if (state && targetStyle.Inverse[state]) {
            style = _objectSpread(_objectSpread({}, style), targetStyle.Inverse[state]);
          }

          if (danger) {
            // inverse danger subtype
            if (targetStyle.Inverse && targetStyle.Inverse.Danger) {
              style = _objectSpread(_objectSpread({}, style), targetStyle.Inverse.Danger);

              if (state && targetStyle.Inverse.Danger[state]) {
                style = _objectSpread(_objectSpread({}, style), targetStyle.Inverse.Danger[state]);
              }
            }
          }
        }
      }

      return style;
    };

    return {
      // style for each should now contain the COMPLETE (including all the inheritance/overriding) style required for that state
      normalStyles: getStyleByState(),
      focusStyles: getStyleByState('Focus'),
      activeStyles: getStyleByState('Active'),
      hoverStyles: getStyleByState('Hover'),
      checkedStyles: getStyleByState('Checked'),
      // only for checkboxes, radio boxes and switches
      indeterminateStyles: getStyleByState('Indeterminate'),
      // only for checkboxes
      visitedStyles: getStyleByState('Visited'),
      // only for links
      // Always get the style for disabled state if readOnly is false, 
      // regardless of whether disabled is currently true or false.
      // If readOnly is true but disabled is specified as true, 
      // we still get the style for disabled state, as `disabled` overwrites `readOnly`
      disabledStyles: !readOnly || disabled ? getStyleByState('Disabled') : {}
    };
  };

  var getFullState = function getFullState(target) {
    switch (target) {
      case ':hover':
        return ':hover:not(:disabled):not(:active)';

      case ':active':
        return ':active:not(:disabled)';

      case ':focus':
        return ':focus:not(:active)';

      case ':disabled':
        return ':disabled';
    }
  };
  /***/

},
/* 17 */

/***/
function (module, exports) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(8);

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 19 */

/***/
function (module, exports) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 20 */

/***/
function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 21 */

/***/
function (module, exports) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 22 */

/***/
function (module, exports) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 23 */

/***/
function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 24 */

/***/
function (module, exports) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 25 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithHoles = __webpack_require__(17);

  var iterableToArrayLimit = __webpack_require__(21);

  var unsupportedIterableToArray = __webpack_require__(10);

  var nonIterableRest = __webpack_require__(22);

  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(18);

  var iterableToArray = __webpack_require__(20);

  var unsupportedIterableToArray = __webpack_require__(10);

  var nonIterableSpread = __webpack_require__(23);

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 27 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_react__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__emotion_react__);
  /* unused harmony default export */


  var _unused_webpack_default_export = function _unused_webpack_default_export() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["Global"], {
      styles: "\n      /* http://meyerweb.com/eric/tools/css/reset/\n        v2.0-modified | 20110126\n        License: none (public domain)\n      */\n\n      html, body, div, span, applet, object, iframe,\n      h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n      a, abbr, acronym, address, big, cite, code,\n      del, dfn, em, img, ins, kbd, q, s, samp,\n      small, strike, strong, sub, sup, tt, var,\n      b, u, i, center,\n      dl, dt, dd, ol, ul, li,\n      fieldset, form, label, legend,\n      table, caption, tbody, tfoot, thead, tr, th, td,\n      article, aside, canvas, details, embed,\n      figure, figcaption, footer, header, hgroup,\n      menu, nav, output, ruby, section, summary,\n      time, mark, audio, video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n      }\n\n      /* make sure to set some focus styles for accessibility */\n      :focus {\n        outline: 0;\n      }\n\n      /* HTML5 display-role reset for older browsers */\n      article, aside, details, figcaption, figure,\n      footer, header, hgroup, menu, nav, section {\n        display: block;\n      }\n\n      body {\n        line-height: 1;\n      }\n\n      ol, ul {\n        list-style: none;\n      }\n\n      blockquote, q {\n        quotes: none;\n      }\n\n      blockquote:before, blockquote:after,\n      q:before, q:after {\n        content: '';\n        content: none;\n      }\n\n      table {\n        border-collapse: collapse;\n        border-spacing: 0;\n      }\n\n      input[type=search]::-webkit-search-cancel-button,\n      input[type=search]::-webkit-search-decoration,\n      input[type=search]::-webkit-search-results-button,\n      input[type=search]::-webkit-search-results-decoration {\n          -webkit-appearance: none;\n          -moz-appearance: none;\n      }\n\n      input[type=search] {\n          -webkit-appearance: none;\n          -moz-appearance: none;\n          -webkit-box-sizing: content-box;\n          -moz-box-sizing: content-box;\n          box-sizing: content-box;\n      }\n\n      textarea {\n          overflow: auto;\n          vertical-align: top;\n          resize: vertical;\n      }\n\n      /**\n      * Correct 'inline-block' display not defined in IE 6/7/8/9 and Firefox 3.\n      */\n\n      audio,\n      canvas,\n      video {\n          display: inline-block;\n          *display: inline;\n          *zoom: 1;\n          max-width: 100%;\n      }\n\n      /**\n      * Prevent modern browsers from displaying 'audio' without controls.\n      * Remove excess height in iOS 5 devices.\n      */\n\n      audio:not([controls]) {\n          display: none;\n          height: 0;\n      }\n\n      /**\n      * Address styling not present in IE 7/8/9, Firefox 3, and Safari 4.\n      * Known issue: no IE 6 support.\n      */\n\n      [hidden] {\n          display: none;\n      }\n\n      /**\n      * 1. Correct text resizing oddly in IE 6/7 when body 'font-size' is set using\n      *    'em' units.\n      * 2. Prevent iOS text size adjust after orientation change, without disabling\n      *    user zoom.\n      */\n\n      html {\n          font-size: 100%; /* 1 */\n          -webkit-text-size-adjust: 100%; /* 2 */\n          -ms-text-size-adjust: 100%; /* 2 */\n      }\n\n      /**\n      * Address 'outline' inconsistency between Chrome and other browsers.\n      */\n\n      a:focus {\n          outline: thin dotted;\n      }\n\n      /**\n      * Improve readability when focused and also mouse hovered in all browsers.\n      */\n\n      a:active,\n      a:hover {\n        outline: 0;\n      }\n\n      /**\n      * 1. Remove border when inside 'a' element in IE 6/7/8/9 and Firefox 3.\n      * 2. Improve image quality when scaled in IE 7.\n      */\n\n      img {\n          border: 0; /* 1 */\n          -ms-interpolation-mode: bicubic; /* 2 */\n      }\n\n      /**\n      * Address margin not present in IE 6/7/8/9, Safari 5, and Opera 11.\n      */\n\n      figure {\n          margin: 0;\n      }\n\n      /**\n      * Correct margin displayed oddly in IE 6/7.\n      */\n\n      form {\n          margin: 0;\n      }\n\n      /**\n      * Define consistent border, margin, and padding.\n      */\n\n      fieldset {\n          border: 1px solid #c0c0c0;\n          margin: 0 2px;\n          padding: 0.35em 0.625em 0.75em;\n      }\n\n      /**\n      * 1. Correct color not being inherited in IE 6/7/8/9.\n      * 2. Correct text not wrapping in Firefox 3.\n      * 3. Correct alignment displayed oddly in IE 6/7.\n      */\n\n      legend {\n          border: 0; /* 1 */\n          padding: 0;\n          white-space: normal; /* 2 */\n          *margin-left: -7px; /* 3 */\n      }\n\n      /**\n      * 1. Correct font size not being inherited in all browsers.\n      * 2. Address margins set differently in IE 6/7, Firefox 3+, Safari 5,\n      *    and Chrome.\n      * 3. Improve appearance and consistency in all browsers.\n      */\n\n      button,\n      input,\n      select,\n      textarea {\n          font: inherit;\n          font-size: 100%; /* 1 */\n          margin: 0; /* 2 */\n          vertical-align: baseline; /* 3 */\n          *vertical-align: middle; /* 3 */\n      }\n\n      /**\n      * Address Firefox 3+ setting 'line-height' on 'input' using '!important' in\n      * the UA stylesheet.\n      */\n\n      button,\n      input {\n          line-height: normal;\n      }\n\n      /**\n      * Address inconsistent 'text-transform' inheritance for 'button' and 'select'.\n      * All other form control elements do not inherit 'text-transform' values.\n      * Correct 'button' style inheritance in Chrome, Safari 5+, and IE 6+.\n      * Correct 'select' style inheritance in Firefox 4+ and Opera.\n      */\n\n      button,\n      select {\n          text-transform: none;\n      }\n\n      /**\n      * 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native 'audio'\n      *    and 'video' controls.\n      * 2. Correct inability to style clickable 'input' types in iOS.\n      * 3. Improve usability and consistency of cursor style between image-type\n      *    'input' and others.\n      * 4. Remove inner spacing in IE 7 without affecting normal text inputs.\n      *    Known issue: inner spacing remains in IE 6.\n      */\n\n      button,\n      html input[type=\"button\"], /* 1 */\n      input[type=\"reset\"],\n      input[type=\"submit\"] {\n          -webkit-appearance: button; /* 2 */\n          cursor: pointer; /* 3 */\n          *overflow: visible;  /* 4 */\n      }\n\n      /**\n      * Re-set default cursor for disabled elements.\n      */\n\n      button[disabled],\n      html input[disabled] {\n          cursor: default;\n      }\n\n      /**\n      * 1. Address box sizing set to content-box in IE 8/9.\n      * 2. Remove excess padding in IE 8/9.\n      * 3. Remove excess padding in IE 7.\n      *    Known issue: excess padding remains in IE 6.\n      */\n\n      input[type=\"checkbox\"],\n      input[type=\"radio\"] {\n          box-sizing: border-box; /* 1 */\n          padding: 0; /* 2 */\n          *height: 13px; /* 3 */\n          *width: 13px; /* 3 */\n      }\n\n      /**\n      * 1. Address 'appearance' set to 'searchfield' in Safari 5 and Chrome.\n      * 2. Address 'box-sizing' set to 'border-box' in Safari 5 and Chrome\n      *    (include '-moz' to future-proof).\n      */\n\n      input[type=\"search\"] {\n          -webkit-appearance: textfield; /* 1 */\n          -moz-box-sizing: content-box;\n          -webkit-box-sizing: content-box; /* 2 */\n          box-sizing: content-box;\n      }\n\n      /**\n      * Remove inner padding and search cancel button in Safari 5 and Chrome\n      * on OS X.\n      */\n\n      input[type=\"search\"]::-webkit-search-cancel-button,\n      input[type=\"search\"]::-webkit-search-decoration {\n          -webkit-appearance: none;\n      }\n\n      /**\n      * Remove inner padding and border in Firefox 3+.\n      */\n\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n          border: 0;\n          padding: 0;\n      }\n\n      /**\n      * 1. Remove default vertical scrollbar in IE 6/7/8/9.\n      * 2. Improve readability and alignment in all browsers.\n      */\n\n      textarea {\n          overflow: auto; /* 1 */\n          vertical-align: top; /* 2 */\n      }\n\n      /**\n      * Remove most spacing between table cells.\n      */\n\n      table {\n          border-collapse: collapse;\n          border-spacing: 0;\n      }\n\n      html,\n      button,\n      input,\n      select,\n      textarea {\n          color: #222;\n      }\n\n\n      ::-moz-selection {\n          background: #b3d4fc;\n          text-shadow: none;\n      }\n\n      ::selection {\n          background: #b3d4fc;\n          text-shadow: none;\n      }\n\n      img {\n          vertical-align: middle;\n      }\n\n      fieldset {\n          border: 0;\n          margin: 0;\n          padding: 0;\n      }\n\n      textarea {\n          resize: vertical;\n      }\n\n      .chromeframe {\n          margin: 0.2em 0;\n          background: #ccc;\n          color: #000;\n          padding: 0.2em 0;\n      }\n\n    "
    });
  };
  /***/

},
/* 28 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(3);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__theme_provider__ = __webpack_require__(2);
  /* harmony default export */


  __webpack_exports__["a"] = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__themes__["b"
    /* getThemes */
    ])()["".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__theme_provider__["a"
    /* getCurrentThemeName */
    ])(), "Fonts")];
  };
  /***/

},
/* 29 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_react__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__emotion_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__emotion_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__with_theme__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__css_reset__ = __webpack_require__(27);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__get_fonts_by_theme__ = __webpack_require__(28);

  var GlobalStyles = function GlobalStyles(_ref) {
    var theme = _ref.theme,
        scoped = _ref.scoped,
        _ref$resetCss = _ref.resetCss,
        resetCss = _ref$resetCss === void 0 ? false : _ref$resetCss;

    var Fonts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__get_fonts_by_theme__["a"
    /* default */
    ])();

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, !scoped ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fonts, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["Global"], {
      styles: theme.Global.NonScopedGlobal
    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__emotion_react__["Global"], {
      styles: theme.Global.ScopedGlobal
    }));
  };
  /* harmony default export */


  __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__with_theme__["a"
  /* default */
  ])(GlobalStyles);
  /***/
},
/* 30 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__ = __webpack_require__(2);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "getCurrentThemeName", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "useThemeSelector", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__["b"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelThemeProvider", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__["c"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ThemeContext", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__["d"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "ThemeConsumer", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_theme_provider__["e"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__components_theme_utils__ = __webpack_require__(16);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "getStylesForStates", function () {
    return __WEBPACK_IMPORTED_MODULE_1__components_theme_utils__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "getFullState", function () {
    return __WEBPACK_IMPORTED_MODULE_1__components_theme_utils__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__components_get_tokens_by_theme__ = __webpack_require__(15);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__components_get_icons_by_theme__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__components_with_theme__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__components_themes__ = __webpack_require__(3);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "withTheme", function () {
    return __WEBPACK_IMPORTED_MODULE_4__components_with_theme__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "getGelTokens", function () {
    return __WEBPACK_IMPORTED_MODULE_2__components_get_tokens_by_theme__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "getGelIcons", function () {
    return __WEBPACK_IMPORTED_MODULE_3__components_get_icons_by_theme__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "configureTheming", function () {
    return __WEBPACK_IMPORTED_MODULE_5__components_themes__["a"];
  }); // TODO: Consider font files for different themes

  /**
   * TODO: Each theme can have different theme objects, tokens, brand icons, ui icons, etc.
   * Make it an option so we can have the component lib incorporate all available themes 
   * (for dynamic theme swapping, eg: great for playground demos)
   * or have the component lib only incorporate one theme at build time to reduce overheads
   * 
   * Alternatively, consider dynamic imports
   * const il = React.lazy(() => import('../themes/il'));
   * const tal = React.lazy(() => import('../themes/tal'));
   * 
   * React.lazy can be used in conjunction with Suspense
   * 
   * Webpack analises the code when packing files, and will create a chunk file 
   * for each piece that is supposed to be dynamically imported. However, those
   * chunk files must be hosted by the server, so that the browser will be able 
   * to fetch them when requested.
   * 
   * https://blog.logrocket.com/speed-up-react-app-dynamic-imports-route-centric-code-splitting/
   * 
   * Prefetching/Preloading modules: 
   * https://webpack.js.org/guides/code-splitting/
   * https://medium.com/front-end-weekly/webpack-and-dynamic-imports-doing-it-right-72549ff49234
   */

  /***/

},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function createExtraScopePlugin() {
    for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
      scopes[_key] = arguments[_key];
    }

    scopes = scopes.map(function (scope) {
      return scope.trim() + " ";
    });
    return function (element) {
      var _element$root;

      if (element.type !== 'rule') {
        return;
      }

      if (((_element$root = element.root) == null ? void 0 : _element$root.type) === '@keyframes') {
        return;
      }

      if (!element.parent || element.props.length === 1 && element.value.charCodeAt(0) !== 58 || !element.length) {
        element.props = element.props.flatMap(function (prop) {
          return scopes.map(function (scope) {
            return scope + prop;
          });
        });
      }
    };
  }

  exports["default"] = createExtraScopePlugin;
  /***/
},
/* 32 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 33 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(35);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(46);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(36);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3__emotion_memoize__ = __webpack_require__(34);

    var last = function last(arr) {
      return arr.length ? arr[arr.length - 1] : null;
    };

    var toRules = function toRules(parsed, points) {
      // pretend we've started with a comma
      var index = -1;
      var character = 44;

      do {
        switch (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["a"
        /* token */
        ])(character)) {
          case 0:
            // &\f
            if (character === 38 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["b"
            /* peek */
            ])() === 12) {
              // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
              // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
              // and when it should just concatenate the outer and inner selectors
              // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
              points[index] = 1;
            }

            parsed[index] += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["c"
            /* identifier */
            ])(__WEBPACK_IMPORTED_MODULE_1_stylis__["d"
            /* position */
            ] - 1);
            break;

          case 2:
            parsed[index] += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["e"
            /* delimit */
            ])(character);
            break;

          case 4:
            // comma
            if (character === 44) {
              // colon
              parsed[++index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["b"
              /* peek */
              ])() === 58 ? '&\f' : '';
              points[index] = parsed[index].length;
              break;
            }

          // fallthrough

          default:
            parsed[index] += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["f"
            /* from */
            ])(character);
        }
      } while (character = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["g"
      /* next */
      ])());

      return parsed;
    };

    var getRules = function getRules(value, points) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["h"
      /* dealloc */
      ])(toRules(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["i"
      /* alloc */
      ])(value), points));
    }; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


    var fixedElements = /* #__PURE__ */new WeakMap();

    var compat = function compat(element) {
      if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
      !element.length) {
        return;
      }

      var value = element.value,
          parent = element.parent;
      var isImplicitRule = element.column === parent.column && element.line === parent.line;

      while (parent.type !== 'rule') {
        parent = parent.parent;
        if (!parent) return;
      } // short-circuit for the simplest case


      if (element.props.length === 1 && value.charCodeAt(0) !== 58
      /* colon */
      && !fixedElements.get(parent)) {
        return;
      } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
      // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


      if (isImplicitRule) {
        return;
      }

      fixedElements.set(element, true);
      var points = [];
      var rules = getRules(value, points);
      var parentRules = parent.props;

      for (var i = 0, k = 0; i < rules.length; i++) {
        for (var j = 0; j < parentRules.length; j++, k++) {
          element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
        }
      }
    };

    var removeLabel = function removeLabel(element) {
      if (element.type === 'decl') {
        var value = element.value;

        if ( // charcode for l
        value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
          // this ignores label
          element["return"] = '';
          element.value = '';
        }
      }
    };

    var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

    var isIgnoringComment = function isIgnoringComment(element) {
      return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
    };

    var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
      return function (element, index, children) {
        if (element.type !== 'rule') return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

        if (unsafePseudoClasses && cache.compat !== true) {
          var prevElement = index > 0 ? children[index - 1] : null;

          if (prevElement && isIgnoringComment(last(prevElement.children))) {
            return;
          }

          unsafePseudoClasses.forEach(function (unsafePseudoClass) {
            console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
          });
        }
      };
    };

    var isImportRule = function isImportRule(element) {
      return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
    };

    var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
      for (var i = index - 1; i >= 0; i--) {
        if (!isImportRule(children[i])) {
          return true;
        }
      }

      return false;
    }; // use this to remove incorrect elements from further processing
    // so they don't get handed to the `sheet` (or anything else)
    // as that could potentially lead to additional logs which in turn could be overhelming to the user


    var nullifyElement = function nullifyElement(element) {
      element.type = '';
      element.value = '';
      element["return"] = '';
      element.children = '';
      element.props = '';
    };

    var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
      if (!isImportRule(element)) {
        return;
      }

      if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
      } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
      }
    };

    var isBrowser = typeof document !== 'undefined';
    var getServerStylisCache = isBrowser ? undefined : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__["a"
    /* default */
    ])(function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__emotion_memoize__["a"
      /* default */
      ])(function () {
        var cache = {};
        return function (name) {
          return cache[name];
        };
      });
    });
    var defaultStylisPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["j"
    /* prefixer */
    ]];

    var createCache = function createCache(options) {
      var key = options.key;

      if (process.env.NODE_ENV !== 'production' && !key) {
        throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
      }

      if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component

        Array.prototype.forEach.call(ssrStyles, function (node) {
          // we want to only move elements which have a space in the data-emotion attribute value
          // because that indicates that it is an Emotion 11 server-side rendered style elements
          // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
          // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
          // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
          // will not result in the Emotion 10 styles being destroyed
          var dataEmotionAttribute = node.getAttribute('data-emotion');

          if (dataEmotionAttribute.indexOf(' ') === -1) {
            return;
          }

          document.head.appendChild(node);
          node.setAttribute('data-s', '');
        });
      }

      var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

      if (process.env.NODE_ENV !== 'production') {
        // $FlowFixMe
        if (/[^a-z-]/.test(key)) {
          throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
        }
      }

      var inserted = {}; // $FlowFixMe

      var container;
      var nodesToHydrate = [];

      if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
        // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
          var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

          for (var i = 1; i < attrib.length; i++) {
            inserted[attrib[i]] = true;
          }

          nodesToHydrate.push(node);
        });
      }

      var _insert;

      var omnipresentPlugins = [compat, removeLabel];

      if (process.env.NODE_ENV !== 'production') {
        omnipresentPlugins.push(createUnsafeSelectorsAlarm({
          get compat() {
            return cache.compat;
          }

        }), incorrectImportAlarm);
      }

      if (isBrowser) {
        var currentSheet;
        var finalizingPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["k"
        /* stringify */
        ], process.env.NODE_ENV !== 'production' ? function (element) {
          if (!element.root) {
            if (element["return"]) {
              currentSheet.insert(element["return"]);
            } else if (element.value && element.type !== __WEBPACK_IMPORTED_MODULE_1_stylis__["l"
            /* COMMENT */
            ]) {
              // insert empty rule in non-production environments
              // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
              currentSheet.insert(element.value + "{}");
            }
          }
        } : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["m"
        /* rulesheet */
        ])(function (rule) {
          currentSheet.insert(rule);
        })];

        var serializer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["n"
        /* middleware */
        ])(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

        var stylis = function stylis(styles) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["o"
          /* serialize */
          ])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["p"
          /* compile */
          ])(styles), serializer);
        };

        _insert = function insert(selector, serialized, sheet, shouldCache) {
          currentSheet = sheet;

          if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
            currentSheet = {
              insert: function insert(rule) {
                sheet.insert(rule + serialized.map);
              }
            };
          }

          stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

          if (shouldCache) {
            cache.inserted[serialized.name] = true;
          }
        };
      } else {
        var _finalizingPlugins = [__WEBPACK_IMPORTED_MODULE_1_stylis__["k"
        /* stringify */
        ]];

        var _serializer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["n"
        /* middleware */
        ])(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

        var _stylis = function _stylis(styles) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["o"
          /* serialize */
          ])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_stylis__["p"
          /* compile */
          ])(styles), _serializer);
        }; // $FlowFixMe


        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

        var getRules = function getRules(selector, serialized) {
          var name = serialized.name;

          if (serverStylisCache[name] === undefined) {
            serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
          }

          return serverStylisCache[name];
        };

        _insert = function _insert(selector, serialized, sheet, shouldCache) {
          var name = serialized.name;
          var rules = getRules(selector, serialized);

          if (cache.compat === undefined) {
            // in regular mode, we don't set the styles on the inserted cache
            // since we don't need to and that would be wasting memory
            // we return them so that they are rendered in a style tag
            if (shouldCache) {
              cache.inserted[name] = true;
            }

            if ( // using === development instead of !== production
            // because if people do ssr in tests, the source maps showing up would be annoying
            process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
              return rules + serialized.map;
            }

            return rules;
          } else {
            // in compat mode, we put the styles on the inserted cache so
            // that emotion-server can pull out the styles
            // except when we don't want to cache it which was in Global but now
            // is nowhere but we don't want to do a major right now
            // and just in case we're going to leave the case here
            // it's also not affecting client side bundle size
            // so it's really not a big deal
            if (shouldCache) {
              cache.inserted[name] = rules;
            } else {
              return rules;
            }
          }
        };
      }

      var cache = {
        key: key,
        sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a"
        /* StyleSheet */
        ]({
          key: key,
          container: container,
          nonce: options.nonce,
          speedy: options.speedy,
          prepend: options.prepend
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
      };
      cache.sheet.hydrate(nodesToHydrate);
      return cache;
    };
    /* harmony default export */


    __webpack_exports__["a"] = createCache;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(0));
  /***/
},
/* 34 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function memoize(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }
  /* harmony default export */


  __webpack_exports__["a"] = memoize;
  /***/
},
/* 35 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return StyleSheet;
    });
    /*
    
    Based off glamor's StyleSheet, thanks Sunil ❤️
    
    high performance StyleSheet for css-in-js systems
    
    - uses multiple style tags behind the scenes for millions of rules
    - uses `insertRule` for appending in production for *much* faster performance
    
    // usage
    
    import { StyleSheet } from '@emotion/sheet'
    
    let styleSheet = new StyleSheet({ key: '', container: document.head })
    
    styleSheet.insert('#box { border: 1px solid red; }')
    - appends a css rule into the stylesheet
    
    styleSheet.flush()
    - empties the stylesheet of all its contents
    
    */
    // $FlowFixMe


    function sheetForTag(tag) {
      if (tag.sheet) {
        // $FlowFixMe
        return tag.sheet;
      } // this weirdness brought to you by firefox

      /* istanbul ignore next */


      for (var i = 0; i < document.styleSheets.length; i++) {
        if (document.styleSheets[i].ownerNode === tag) {
          // $FlowFixMe
          return document.styleSheets[i];
        }
      }
    }

    function createStyleElement(options) {
      var tag = document.createElement('style');
      tag.setAttribute('data-emotion', options.key);

      if (options.nonce !== undefined) {
        tag.setAttribute('nonce', options.nonce);
      }

      tag.appendChild(document.createTextNode(''));
      tag.setAttribute('data-s', '');
      return tag;
    }

    var StyleSheet = /*#__PURE__*/function () {
      function StyleSheet(options) {
        var _this = this;

        this._insertTag = function (tag) {
          var before;

          if (_this.tags.length === 0) {
            before = _this.prepend ? _this.container.firstChild : _this.before;
          } else {
            before = _this.tags[_this.tags.length - 1].nextSibling;
          }

          _this.container.insertBefore(tag, before);

          _this.tags.push(tag);
        };

        this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.before = null;
      }

      var _proto = StyleSheet.prototype;

      _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
      };

      _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
          this._insertTag(createStyleElement(this));
        }

        var tag = this.tags[this.tags.length - 1];

        if (process.env.NODE_ENV !== 'production') {
          var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

          if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
            // this would only cause problem in speedy mode
            // but we don't want enabling speedy to affect the observable behavior
            // so we report this error at all times
            console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
          }

          this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
        }

        if (this.isSpeedy) {
          var sheet = sheetForTag(tag);

          try {
            // this is the ultrafast version, works across browsers
            // the big drawback is that the css won't be editable in devtools
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (e) {
            if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
              console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
            }
          }
        } else {
          tag.appendChild(document.createTextNode(rule));
        }

        this.ctr++;
      };

      _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function (tag) {
          return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;

        if (process.env.NODE_ENV !== 'production') {
          this._alreadyInsertedOrderInsensitiveRule = false;
        }
      };

      return StyleSheet;
    }();
    /* WEBPACK VAR INJECTION */

  }).call(__webpack_exports__, __webpack_require__(0));
  /***/
},
/* 36 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = weakMemoize;
  /***/
},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret = __webpack_require__(5);

      var loggedTypeFailures = {};
      var has = Function.call.bind(Object.prototype.hasOwnProperty);

      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                err.name = 'Invariant Violation';
                throw err;
              }

              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            if (error && !(error instanceof Error)) {
              printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
            }

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
            }
          }
        }
      }
    }
    /**
     * Resets warning cache when testing.
     *
     * @private
     */


    checkPropTypes.resetWarningCache = function () {
      if (process.env.NODE_ENV !== 'production') {
        loggedTypeFailures = {};
      }
    };

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(0));
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = __webpack_require__(5);

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var ReactIs = __webpack_require__(12);

    var assign = __webpack_require__(11);

    var ReactPropTypesSecret = __webpack_require__(5);

    var checkPropTypes = __webpack_require__(37);

    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    function emptyFunctionThatReturnsNull() {
      return null;
    }

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== 'production') {
            if (arguments.length > 1) {
              printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
            } else {
              printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
          }

          return emptyFunctionThatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);

            if (type === 'symbol') {
              return String(value);
            }

            return value;
          });
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
            return emptyFunctionThatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          } // We need to check all keys in case some are required but missing from
          // props.


          var allKeys = assign({}, props[propName], shapeTypes);

          for (var key in allKeys) {
            var checker = shapeTypes[key];

            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // falsy value can't be a Symbol


        if (!propValue) {
          return false;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = typeof propValue;

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(0));
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = __webpack_require__(12); // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(39)(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(38)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(0));
  /***/
},
/* 41 */

/***/
function (module, exports) {
  /* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
  var hasElementType = typeof Element !== 'undefined';
  var hasMap = typeof Map === 'function';
  var hasSet = typeof Set === 'function';
  var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView; // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

  function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
      if (a.constructor !== b.constructor) return false;
      var length, i, keys;

      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;

        for (i = length; i-- !== 0;) {
          if (!equal(a[i], b[i])) return false;
        }

        return true;
      } // START: Modifications:
      // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
      //    to co-exist with es5.
      // 2. Replace `for of` with es5 compliant iteration using `for`.
      //    Basically, take:
      //
      //    ```js
      //    for (i of a.entries())
      //      if (!b.has(i[0])) return false;
      //    ```
      //
      //    ... and convert to:
      //
      //    ```js
      //    it = a.entries();
      //    while (!(i = it.next()).done)
      //      if (!b.has(i.value[0])) return false;
      //    ```
      //
      //    **Note**: `i` access switches to `i.value`.


      var it;

      if (hasMap && a instanceof Map && b instanceof Map) {
        if (a.size !== b.size) return false;
        it = a.entries();

        while (!(i = it.next()).done) {
          if (!b.has(i.value[0])) return false;
        }

        it = a.entries();

        while (!(i = it.next()).done) {
          if (!equal(i.value[1], b.get(i.value[0]))) return false;
        }

        return true;
      }

      if (hasSet && a instanceof Set && b instanceof Set) {
        if (a.size !== b.size) return false;
        it = a.entries();

        while (!(i = it.next()).done) {
          if (!b.has(i.value[0])) return false;
        }

        return true;
      } // END: Modifications


      if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
        length = a.length;
        if (length != b.length) return false;

        for (i = length; i-- !== 0;) {
          if (a[i] !== b[i]) return false;
        }

        return true;
      }

      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;

      for (i = length; i-- !== 0;) {
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      } // END: fast-deep-equal
      // START: react-fast-compare
      // custom handling for DOM elements


      if (hasElementType && a instanceof Element) return false; // custom handling for React/Preact

      for (i = length; i-- !== 0;) {
        if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner
          // Preact-specific: avoid traversing Preact elements' __v and __o
          //    __v = $_original / $_vnode
          //    __o = $_owner
          // These properties contain circular references and are not needed when
          // comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of elements
          continue;
        } // all other properties should be traversed as usual


        if (!equal(a[keys[i]], b[keys[i]])) return false;
      } // END: react-fast-compare
      // START: fast-deep-equal


      return true;
    }

    return a !== a && b !== b;
  } // end fast-deep-equal


  module.exports = function isEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if ((error.message || '').match(/stack|recursion/i)) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('react-fast-compare cannot handle circular refs');
        return false;
      } // some other error. we should definitely know about these


      throw error;
    }
  };
  /***/

},
/* 42 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global, process) {
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return HelmetExport;
    });
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(40);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(45);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(41);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(1);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(11);
    /* harmony import */


    var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);

    var ATTRIBUTE_NAMES = {
      BODY: "bodyAttributes",
      HTML: "htmlAttributes",
      TITLE: "titleAttributes"
    };
    var TAG_NAMES = {
      BASE: "base",
      BODY: "body",
      HEAD: "head",
      HTML: "html",
      LINK: "link",
      META: "meta",
      NOSCRIPT: "noscript",
      SCRIPT: "script",
      STYLE: "style",
      TITLE: "title"
    };
    var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
      return TAG_NAMES[name];
    });
    var TAG_PROPERTIES = {
      CHARSET: "charset",
      CSS_TEXT: "cssText",
      HREF: "href",
      HTTPEQUIV: "http-equiv",
      INNER_HTML: "innerHTML",
      ITEM_PROP: "itemprop",
      NAME: "name",
      PROPERTY: "property",
      REL: "rel",
      SRC: "src",
      TARGET: "target"
    };
    var REACT_TAG_MAP = {
      accesskey: "accessKey",
      charset: "charSet",
      class: "className",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      "http-equiv": "httpEquiv",
      itemprop: "itemProp",
      tabindex: "tabIndex"
    };
    var HELMET_PROPS = {
      DEFAULT_TITLE: "defaultTitle",
      DEFER: "defer",
      ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
      ON_CHANGE_CLIENT_STATE: "onChangeClientState",
      TITLE_TEMPLATE: "titleTemplate"
    };
    var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
      obj[REACT_TAG_MAP[key]] = key;
      return obj;
    }, {});
    var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
    var HELMET_ATTRIBUTE = "data-react-helmet";

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    var classCallCheck = function classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var inherits = function inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };

    var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    };

    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };

    var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
      var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (encode === false) {
        return String(str);
      }

      return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
    };

    var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
      var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
      var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

      if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
          return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
      }

      var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
      return innermostTitle || innermostDefaultTitle || undefined;
    };

    var getOnChangeClientState = function getOnChangeClientState(propsList) {
      return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
    };

    var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
      return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
      }).map(function (props) {
        return props[tagType];
      }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
      }, {});
    };

    var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
      return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
      }).map(function (props) {
        return props[TAG_NAMES.BASE];
      }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
          var keys = Object.keys(tag);

          for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var lowerCaseAttributeKey = attributeKey.toLowerCase();

            if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
              return innermostBaseTag.concat(tag);
            }
          }
        }

        return innermostBaseTag;
      }, []);
    };

    var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
      // Calculate list of tags, giving priority innermost component (end of the propslist)
      var approvedSeenTags = {};
      return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
          return true;
        }

        if (typeof props[tagName] !== "undefined") {
          warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }

        return false;
      }).map(function (props) {
        return props[tagName];
      }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function (tag) {
          var primaryAttributeKey = void 0;
          var keys = Object.keys(tag);

          for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var lowerCaseAttributeKey = attributeKey.toLowerCase(); // Special rule with link tags, since rel and href are both primary tags, rel takes priority

            if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
              primaryAttributeKey = lowerCaseAttributeKey;
            } // Special case for innerHTML which doesn't work lowercased


            if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
              primaryAttributeKey = attributeKey;
            }
          }

          if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
            return false;
          }

          var value = tag[primaryAttributeKey].toLowerCase();

          if (!approvedSeenTags[primaryAttributeKey]) {
            approvedSeenTags[primaryAttributeKey] = {};
          }

          if (!instanceSeenTags[primaryAttributeKey]) {
            instanceSeenTags[primaryAttributeKey] = {};
          }

          if (!approvedSeenTags[primaryAttributeKey][value]) {
            instanceSeenTags[primaryAttributeKey][value] = true;
            return true;
          }

          return false;
        }).reverse().forEach(function (tag) {
          return approvedTags.push(tag);
        }); // Update seen tags with tags from this instance

        var keys = Object.keys(instanceSeenTags);

        for (var i = 0; i < keys.length; i++) {
          var attributeKey = keys[i];

          var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

          approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
      }, []).reverse();
    };

    var getInnermostProperty = function getInnermostProperty(propsList, property) {
      for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
          return props[property];
        }
      }

      return null;
    };

    var reducePropsToState = function reducePropsToState(propsList) {
      return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
      };
    };

    var rafPolyfill = function () {
      var clock = Date.now();
      return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
          clock = currentTime;
          callback(currentTime);
        } else {
          setTimeout(function () {
            rafPolyfill(callback);
          }, 0);
        }
      };
    }();

    var cafPolyfill = function cafPolyfill(id) {
      return clearTimeout(id);
    };

    var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
    var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

    var warn = function warn(msg) {
      return console && typeof console.warn === "function" && console.warn(msg);
    };

    var _helmetCallback = null;

    var handleClientStateChange = function handleClientStateChange(newState) {
      if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
      }

      if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
          commitTagChanges(newState, function () {
            _helmetCallback = null;
          });
        });
      } else {
        commitTagChanges(newState);
        _helmetCallback = null;
      }
    };

    var commitTagChanges = function commitTagChanges(newState, cb) {
      var baseTag = newState.baseTag,
          bodyAttributes = newState.bodyAttributes,
          htmlAttributes = newState.htmlAttributes,
          linkTags = newState.linkTags,
          metaTags = newState.metaTags,
          noscriptTags = newState.noscriptTags,
          onChangeClientState = newState.onChangeClientState,
          scriptTags = newState.scriptTags,
          styleTags = newState.styleTags,
          title = newState.title,
          titleAttributes = newState.titleAttributes;
      updateAttributes(TAG_NAMES.BODY, bodyAttributes);
      updateAttributes(TAG_NAMES.HTML, htmlAttributes);
      updateTitle(title, titleAttributes);
      var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
      };
      var addedTags = {};
      var removedTags = {};
      Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;

        if (newTags.length) {
          addedTags[tagType] = newTags;
        }

        if (oldTags.length) {
          removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
      });
      cb && cb();
      onChangeClientState(newState, addedTags, removedTags);
    };

    var flattenArray = function flattenArray(possibleArray) {
      return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
    };

    var updateTitle = function updateTitle(title, attributes) {
      if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
      }

      updateAttributes(TAG_NAMES.TITLE, attributes);
    };

    var updateAttributes = function updateAttributes(tagName, attributes) {
      var elementTag = document.getElementsByTagName(tagName)[0];

      if (!elementTag) {
        return;
      }

      var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
      var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
      var attributesToRemove = [].concat(helmetAttributes);
      var attributeKeys = Object.keys(attributes);

      for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
          elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
          helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);

        if (indexToSave !== -1) {
          attributesToRemove.splice(indexToSave, 1);
        }
      }

      for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
      }

      if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
      } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
      }
    };

    var updateTags = function updateTags(type, tags) {
      var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
      var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
      var oldTags = Array.prototype.slice.call(tagNodes);
      var newTags = [];
      var indexToDelete = void 0;

      if (tags && tags.length) {
        tags.forEach(function (tag) {
          var newElement = document.createElement(type);

          for (var attribute in tag) {
            if (tag.hasOwnProperty(attribute)) {
              if (attribute === TAG_PROPERTIES.INNER_HTML) {
                newElement.innerHTML = tag.innerHTML;
              } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) {
                  newElement.styleSheet.cssText = tag.cssText;
                } else {
                  newElement.appendChild(document.createTextNode(tag.cssText));
                }
              } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
              }
            }
          }

          newElement.setAttribute(HELMET_ATTRIBUTE, "true"); // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.

          if (oldTags.some(function (existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
          })) {
            oldTags.splice(indexToDelete, 1);
          } else {
            newTags.push(newElement);
          }
        });
      }

      oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
      });
      return {
        oldTags: oldTags,
        newTags: newTags
      };
    };

    var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
      return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
      }, "");
    };

    var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
      var attributeString = generateElementAttributesAsString(attributes);
      var flattenedTitle = flattenArray(title);
      return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
    };

    var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
      return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
          return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
          var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
          return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
      }, "");
    };

    var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
      var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
      }, initProps);
    };

    var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
      var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
      }, initAttributes);
    };

    var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
      var _initProps; // assigning into an array to define toString function on it


      var initProps = (_initProps = {
        key: title
      }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
      var props = convertElementAttributestoReactProps(attributes, initProps);
      return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
    };

    var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
      return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
          key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function (attribute) {
          var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

          if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
            var content = tag.innerHTML || tag.cssText;
            mappedTag.dangerouslySetInnerHTML = {
              __html: content
            };
          } else {
            mappedTag[mappedAttribute] = tag[attribute];
          }
        });
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
      });
    };

    var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
      switch (type) {
        case TAG_NAMES.TITLE:
          return {
            toComponent: function toComponent() {
              return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
            },
            toString: function toString() {
              return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
            }
          };

        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
          return {
            toComponent: function toComponent() {
              return convertElementAttributestoReactProps(tags);
            },
            toString: function toString() {
              return generateElementAttributesAsString(tags);
            }
          };

        default:
          return {
            toComponent: function toComponent() {
              return generateTagsAsReactComponent(type, tags);
            },
            toString: function toString() {
              return generateTagsAsString(type, tags, encode);
            }
          };
      }
    };

    var mapStateOnServer = function mapStateOnServer(_ref) {
      var baseTag = _ref.baseTag,
          bodyAttributes = _ref.bodyAttributes,
          encode = _ref.encode,
          htmlAttributes = _ref.htmlAttributes,
          linkTags = _ref.linkTags,
          metaTags = _ref.metaTags,
          noscriptTags = _ref.noscriptTags,
          scriptTags = _ref.scriptTags,
          styleTags = _ref.styleTags,
          _ref$title = _ref.title,
          title = _ref$title === undefined ? "" : _ref$title,
          titleAttributes = _ref.titleAttributes;
      return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, {
          title: title,
          titleAttributes: titleAttributes
        }, encode)
      };
    };

    var Helmet = function Helmet(Component) {
      var _class, _temp;

      return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
          classCallCheck(this, HelmetWrapper);
          return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
          if (!nestedChildren) {
            return null;
          }

          switch (child.type) {
            case TAG_NAMES.SCRIPT:
            case TAG_NAMES.NOSCRIPT:
              return {
                innerHTML: nestedChildren
              };

            case TAG_NAMES.STYLE:
              return {
                cssText: nestedChildren
              };
          }

          throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
          var _babelHelpers$extends;

          var child = _ref.child,
              arrayTypeChildren = _ref.arrayTypeChildren,
              newChildProps = _ref.newChildProps,
              nestedChildren = _ref.nestedChildren;
          return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
          var _babelHelpers$extends2, _babelHelpers$extends3;

          var child = _ref2.child,
              newProps = _ref2.newProps,
              newChildProps = _ref2.newChildProps,
              nestedChildren = _ref2.nestedChildren;

          switch (child.type) {
            case TAG_NAMES.TITLE:
              return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

            case TAG_NAMES.BODY:
              return _extends({}, newProps, {
                bodyAttributes: _extends({}, newChildProps)
              });

            case TAG_NAMES.HTML:
              return _extends({}, newProps, {
                htmlAttributes: _extends({}, newChildProps)
              });
          }

          return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
          var newFlattenedProps = _extends({}, newProps);

          Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
            var _babelHelpers$extends4;

            newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
          });
          return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
          if (process.env.NODE_ENV !== "production") {
            if (!VALID_TAG_NAMES.some(function (name) {
              return child.type === name;
            })) {
              if (typeof child.type === "function") {
                return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
              }

              return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
            }

            if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
              return typeof nestedChild !== "string";
            }))) {
              throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
            }
          }

          return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
          var _this2 = this;

          var arrayTypeChildren = {};

          __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
            if (!child || !child.props) {
              return;
            }

            var _child$props = child.props,
                nestedChildren = _child$props.children,
                childProps = objectWithoutProperties(_child$props, ["children"]);
            var newChildProps = convertReactPropstoHtmlAttributes(childProps);

            _this2.warnOnInvalidChildren(child, nestedChildren);

            switch (child.type) {
              case TAG_NAMES.LINK:
              case TAG_NAMES.META:
              case TAG_NAMES.NOSCRIPT:
              case TAG_NAMES.SCRIPT:
              case TAG_NAMES.STYLE:
                arrayTypeChildren = _this2.flattenArrayTypeChildren({
                  child: child,
                  arrayTypeChildren: arrayTypeChildren,
                  newChildProps: newChildProps,
                  nestedChildren: nestedChildren
                });
                break;

              default:
                newProps = _this2.mapObjectTypeChildren({
                  child: child,
                  newProps: newProps,
                  newChildProps: newChildProps,
                  nestedChildren: nestedChildren
                });
                break;
            }
          });

          newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
          return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
          var _props = this.props,
              children = _props.children,
              props = objectWithoutProperties(_props, ["children"]);

          var newProps = _extends({}, props);

          if (children) {
            newProps = this.mapChildrenToProps(children, newProps);
          }

          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
          key: "canUseDOM",
          // Component.peek comes from react-side-effect:
          // For testing, you may use a static peek() method available on the returned component.
          // It lets you get the current state without resetting the mounted instance stack.
          // Don’t use it for anything other than testing.

          /**
           * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
           * @param {Object} bodyAttributes: {"className": "root"}
           * @param {String} defaultTitle: "Default Title"
           * @param {Boolean} defer: true
           * @param {Boolean} encodeSpecialCharacters: true
           * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
           * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
           * @param {Array} meta: [{"name": "description", "content": "Test description"}]
           * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
           * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
           * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
           * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
           * @param {String} title: "Title"
           * @param {Object} titleAttributes: {"itemprop": "name"}
           * @param {String} titleTemplate: "MySite.com - %s"
           */
          set: function set$$1(canUseDOM) {
            Component.canUseDOM = canUseDOM;
          }
        }]);
        return HelmetWrapper;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
      }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
      }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();

        if (!mappedState) {
          // provide fallback if mappedState is undefined
          mappedState = mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
          });
        }

        return mappedState;
      }, _temp;
    };

    var NullComponent = function NullComponent() {
      return null;
    };

    var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

    var HelmetExport = Helmet(HelmetSideEffects);
    HelmetExport.renderStatic = HelmetExport.rewind;
    /* unused harmony default export */

    var _unused_webpack_default_export = HelmetExport;
    /* WEBPACK VAR INJECTION */
  }).call(__webpack_exports__, __webpack_require__(32), __webpack_require__(0));
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v16.13.1
    * react-is.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict'; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
          if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }

          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode


        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

              console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(0));
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.block") : 60121,
      w = b ? Symbol.for("react.fundamental") : 60117,
      x = b ? Symbol.for("react.responder") : 60118,
      y = b ? Symbol.for("react.scope") : 60119;

  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function A(a) {
    return z(a) === m;
  }

  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };

  exports.isConcurrentMode = A;

  exports.isContextConsumer = function (a) {
    return z(a) === k;
  };

  exports.isContextProvider = function (a) {
    return z(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return z(a) === n;
  };

  exports.isFragment = function (a) {
    return z(a) === e;
  };

  exports.isLazy = function (a) {
    return z(a) === t;
  };

  exports.isMemo = function (a) {
    return z(a) === r;
  };

  exports.isPortal = function (a) {
    return z(a) === d;
  };

  exports.isProfiler = function (a) {
    return z(a) === g;
  };

  exports.isStrictMode = function (a) {
    return z(a) === f;
  };

  exports.isSuspense = function (a) {
    return z(a) === p;
  };

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };

  exports.typeOf = z;
  /***/
},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
  }

  var React = __webpack_require__(1);

  var React__default = _interopDefault(React);

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }

    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
      throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    }

    function getDisplayName(WrappedComponent) {
      return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }

    return function wrap(WrappedComponent) {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }

      var mountedInstances = [];
      var state;

      function emitChange() {
        state = reducePropsToState(mountedInstances.map(function (instance) {
          return instance.props;
        }));

        if (SideEffect.canUseDOM) {
          handleStateChangeOnClient(state);
        } else if (mapStateOnServer) {
          state = mapStateOnServer(state);
        }
      }

      var SideEffect = /*#__PURE__*/function (_PureComponent) {
        _inheritsLoose(SideEffect, _PureComponent);

        function SideEffect() {
          return _PureComponent.apply(this, arguments) || this;
        } // Try to use displayName of wrapped component
        // Expose canUseDOM so tests can monkeypatch it


        SideEffect.peek = function peek() {
          return state;
        };

        SideEffect.rewind = function rewind() {
          if (SideEffect.canUseDOM) {
            throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
          }

          var recordedState = state;
          state = undefined;
          mountedInstances = [];
          return recordedState;
        };

        var _proto = SideEffect.prototype;

        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
          mountedInstances.push(this);
          emitChange();
        };

        _proto.componentDidUpdate = function componentDidUpdate() {
          emitChange();
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          var index = mountedInstances.indexOf(this);
          mountedInstances.splice(index, 1);
          emitChange();
        };

        _proto.render = function render() {
          return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
        };

        return SideEffect;
      }(React.PureComponent);

      _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

      _defineProperty(SideEffect, "canUseDOM", canUseDOM);

      return SideEffect;
    };
  }

  module.exports = withSideEffect;
  /***/
},
/* 46 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export CHARSET */

  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "l", function () {
    return c;
  });
  /* unused harmony export COUNTER_STYLE */

  /* unused harmony export DECLARATION */

  /* unused harmony export DOCUMENT */

  /* unused harmony export FONT_FACE */

  /* unused harmony export FONT_FEATURE_VALUES */

  /* unused harmony export IMPORT */

  /* unused harmony export KEYFRAMES */

  /* unused harmony export MEDIA */

  /* unused harmony export MOZ */

  /* unused harmony export MS */

  /* unused harmony export NAMESPACE */

  /* unused harmony export PAGE */

  /* unused harmony export RULESET */

  /* unused harmony export SUPPORTS */

  /* unused harmony export VIEWPORT */

  /* unused harmony export WEBKIT */

  /* unused harmony export abs */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return T;
  });
  /* unused harmony export append */

  /* unused harmony export caret */

  /* unused harmony export char */

  /* unused harmony export character */

  /* unused harmony export characters */

  /* unused harmony export charat */

  /* unused harmony export column */

  /* unused harmony export combine */

  /* unused harmony export comment */

  /* unused harmony export commenter */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "p", function () {
    return ae;
  });
  /* unused harmony export copy */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return U;
  });
  /* unused harmony export declaration */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return V;
  });
  /* unused harmony export delimiter */

  /* unused harmony export escaping */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return d;
  });
  /* unused harmony export hash */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return re;
  });
  /* unused harmony export indexof */

  /* unused harmony export length */

  /* unused harmony export line */

  /* unused harmony export match */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "n", function () {
    return oe;
  });
  /* unused harmony export namespace */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return L;
  });
  /* unused harmony export node */

  /* unused harmony export parse */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return N;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return E;
  });
  /* unused harmony export prefix */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "j", function () {
    return ve;
  });
  /* unused harmony export prev */

  /* unused harmony export replace */

  /* unused harmony export ruleset */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "m", function () {
    return le;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "o", function () {
    return ie;
  });
  /* unused harmony export sizeof */

  /* unused harmony export slice */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "k", function () {
    return fe;
  });
  /* unused harmony export strlen */

  /* unused harmony export substr */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return R;
  });
  /* unused harmony export tokenize */

  /* unused harmony export tokenizer */

  /* unused harmony export trim */

  /* unused harmony export whitespace */


  var e = "-ms-";
  var r = "-moz-";
  var a = "-webkit-";
  var c = "comm";
  var n = "rule";
  var t = "decl";
  var s = "@page";
  var u = "@media";
  var i = "@import";
  var f = "@charset";
  var o = "@viewport";
  var l = "@supports";
  var v = "@document";
  var h = "@namespace";
  var p = "@keyframes";
  var b = "@font-face";
  var w = "@counter-style";
  var $ = "@font-feature-values";
  var k = Math.abs;
  var d = String.fromCharCode;

  function m(e, r) {
    return (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3);
  }

  function g(e) {
    return e.trim();
  }

  function x(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
  }

  function y(e, r, a) {
    return e.replace(r, a);
  }

  function j(e, r) {
    return e.indexOf(r);
  }

  function z(e, r) {
    return e.charCodeAt(r) | 0;
  }

  function C(e, r, a) {
    return e.slice(r, a);
  }

  function A(e) {
    return e.length;
  }

  function M(e) {
    return e.length;
  }

  function O(e, r) {
    return r.push(e), e;
  }

  function S(e, r) {
    return e.map(r).join("");
  }

  var q = 1;
  var B = 1;
  var D = 0;
  var E = 0;
  var F = 0;
  var G = "";

  function H(e, r, a, c, n, t, s) {
    return {
      value: e,
      root: r,
      parent: a,
      type: c,
      props: n,
      children: t,
      line: q,
      column: B,
      length: s,
      return: ""
    };
  }

  function I(e, r, a) {
    return H(e, r.root, r.parent, a, r.props, r.children, 0);
  }

  function J() {
    return F;
  }

  function K() {
    F = E > 0 ? z(G, --E) : 0;
    if (B--, F === 10) B = 1, q--;
    return F;
  }

  function L() {
    F = E < D ? z(G, E++) : 0;
    if (B++, F === 10) B = 1, q++;
    return F;
  }

  function N() {
    return z(G, E);
  }

  function P() {
    return E;
  }

  function Q(e, r) {
    return C(G, e, r);
  }

  function R(e) {
    switch (e) {
      case 0:
      case 9:
      case 10:
      case 13:
      case 32:
        return 5;

      case 33:
      case 43:
      case 44:
      case 47:
      case 62:
      case 64:
      case 126:
      case 59:
      case 123:
      case 125:
        return 4;

      case 58:
        return 3;

      case 34:
      case 39:
      case 40:
      case 91:
        return 2;

      case 41:
      case 93:
        return 1;
    }

    return 0;
  }

  function T(e) {
    return q = B = 1, D = A(G = e), E = 0, [];
  }

  function U(e) {
    return G = "", e;
  }

  function V(e) {
    return g(Q(E - 1, _(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
  }

  function W(e) {
    return U(Y(T(e)));
  }

  function X(e) {
    while (F = N()) {
      if (F < 33) L();else break;
    }

    return R(e) > 2 || R(F) > 3 ? "" : " ";
  }

  function Y(e) {
    while (L()) {
      switch (R(F)) {
        case 0:
          O(re(E - 1), e);
          break;

        case 2:
          O(V(F), e);
          break;

        default:
          O(d(F), e);
      }
    }

    return e;
  }

  function Z(e, r) {
    while (--r && L()) {
      if (F < 48 || F > 102 || F > 57 && F < 65 || F > 70 && F < 97) break;
    }

    return Q(e, P() + (r < 6 && N() == 32 && L() == 32));
  }

  function _(e) {
    while (L()) {
      switch (F) {
        case e:
          return E;

        case 34:
        case 39:
          return _(e === 34 || e === 39 ? e : F);

        case 40:
          if (e === 41) _(e);
          break;

        case 92:
          L();
          break;
      }
    }

    return E;
  }

  function ee(e, r) {
    while (L()) {
      if (e + F === 47 + 10) break;else if (e + F === 42 + 42 && N() === 47) break;
    }

    return "/*" + Q(r, E - 1) + "*" + d(e === 47 ? e : L());
  }

  function re(e) {
    while (!R(N())) {
      L();
    }

    return Q(e, E);
  }

  function ae(e) {
    return U(ce("", null, null, null, [""], e = T(e), 0, [0], e));
  }

  function ce(e, r, a, c, n, t, s, u, i) {
    var f = 0;
    var o = 0;
    var l = s;
    var v = 0;
    var h = 0;
    var p = 0;
    var b = 1;
    var w = 1;
    var $ = 1;
    var k = 0;
    var m = "";
    var g = n;
    var x = t;
    var j = c;
    var z = m;

    while (w) {
      switch (p = k, k = L()) {
        case 34:
        case 39:
        case 91:
        case 40:
          z += V(k);
          break;

        case 9:
        case 10:
        case 13:
        case 32:
          z += X(p);
          break;

        case 92:
          z += Z(P() - 1, 7);
          continue;

        case 47:
          switch (N()) {
            case 42:
            case 47:
              O(te(ee(L(), P()), r, a), i);
              break;

            default:
              z += "/";
          }

          break;

        case 123 * b:
          u[f++] = A(z) * $;

        case 125 * b:
        case 59:
        case 0:
          switch (k) {
            case 0:
            case 125:
              w = 0;

            case 59 + o:
              if (h > 0 && A(z) - l) O(h > 32 ? se(z + ";", c, a, l - 1) : se(y(z, " ", "") + ";", c, a, l - 2), i);
              break;

            case 59:
              z += ";";

            default:
              O(j = ne(z, r, a, f, o, n, u, m, g = [], x = [], l), t);
              if (k === 123) if (o === 0) ce(z, r, j, j, g, t, l, u, x);else switch (v) {
                case 100:
                case 109:
                case 115:
                  ce(e, j, j, c && O(ne(e, j, j, 0, 0, n, u, m, n, g = [], l), x), n, x, l, u, c ? g : x);
                  break;

                default:
                  ce(z, j, j, j, [""], x, l, u, x);
              }
          }

          f = o = h = 0, b = $ = 1, m = z = "", l = s;
          break;

        case 58:
          l = 1 + A(z), h = p;

        default:
          if (b < 1) if (k == 123) --b;else if (k == 125 && b++ == 0 && K() == 125) continue;

          switch (z += d(k), k * b) {
            case 38:
              $ = o > 0 ? 1 : (z += "\f", -1);
              break;

            case 44:
              u[f++] = (A(z) - 1) * $, $ = 1;
              break;

            case 64:
              if (N() === 45) z += V(L());
              v = N(), o = A(m = z += re(P())), k++;
              break;

            case 45:
              if (p === 45 && A(z) == 2) b = 0;
          }

      }
    }

    return t;
  }

  function ne(e, r, a, c, t, s, u, i, f, o, l) {
    var v = t - 1;
    var h = t === 0 ? s : [""];
    var p = M(h);

    for (var b = 0, w = 0, $ = 0; b < c; ++b) {
      for (var d = 0, m = C(e, v + 1, v = k(w = u[b])), x = e; d < p; ++d) {
        if (x = g(w > 0 ? h[d] + " " + m : y(m, /&\f/g, h[d]))) f[$++] = x;
      }
    }

    return H(e, r, a, t === 0 ? n : i, f, o, l);
  }

  function te(e, r, a) {
    return H(e, r, a, c, d(J()), C(e, 2, -2), 0);
  }

  function se(e, r, a, c) {
    return H(e, r, a, t, C(e, 0, c), C(e, c + 1, -1), c);
  }

  function ue(c, n) {
    switch (m(c, n)) {
      case 5103:
        return a + "print-" + c + c;

      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921:
      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005:
      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855:
      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return a + c + c;

      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return a + c + r + c + e + c + c;

      case 6828:
      case 4268:
        return a + c + e + c + c;

      case 6165:
        return a + c + e + "flex-" + c + c;

      case 5187:
        return a + c + y(c, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c;

      case 5443:
        return a + c + e + "flex-item-" + y(c, /flex-|-self/, "") + c;

      case 4675:
        return a + c + e + "flex-line-pack" + y(c, /align-content|flex-|-self/, "") + c;

      case 5548:
        return a + c + e + y(c, "shrink", "negative") + c;

      case 5292:
        return a + c + e + y(c, "basis", "preferred-size") + c;

      case 6060:
        return a + "box-" + y(c, "-grow", "") + a + c + e + y(c, "grow", "positive") + c;

      case 4554:
        return a + y(c, /([^-])(transform)/g, "$1" + a + "$2") + c;

      case 6187:
        return y(y(y(c, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c, "") + c;

      case 5495:
      case 3959:
        return y(c, /(image-set\([^]*)/, a + "$1" + "$`$1");

      case 4968:
        return y(y(c, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + c + c;

      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return y(c, /(.+)-inline(.+)/, a + "$1$2") + c;

      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        if (A(c) - 1 - n > 6) switch (z(c, n + 1)) {
          case 109:
            if (z(c, n + 4) !== 45) break;

          case 102:
            return y(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (z(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;

          case 115:
            return ~j(c, "stretch") ? ue(y(c, "stretch", "fill-available"), n) + c : c;
        }
        break;

      case 4949:
        if (z(c, n + 1) !== 115) break;

      case 6444:
        switch (z(c, A(c) - 3 - (~j(c, "!important") && 10))) {
          case 107:
            return y(c, ":", ":" + a) + c;

          case 101:
            return y(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (z(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + c;
        }

        break;

      case 5936:
        switch (z(c, n + 11)) {
          case 114:
            return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "tb") + c;

          case 108:
            return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;

          case 45:
            return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
        }

        return a + c + e + c + c;
    }

    return c;
  }

  function ie(e, r) {
    var a = "";
    var c = M(e);

    for (var n = 0; n < c; n++) {
      a += r(e[n], n, e, r) || "";
    }

    return a;
  }

  function fe(e, r, a, s) {
    switch (e.type) {
      case i:
      case t:
        return e.return = e.return || e.value;

      case c:
        return "";

      case n:
        e.value = e.props.join(",");
    }

    return A(a = ie(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
  }

  function oe(e) {
    var r = M(e);
    return function (a, c, n, t) {
      var s = "";

      for (var u = 0; u < r; u++) {
        s += e[u](a, c, n, t) || "";
      }

      return s;
    };
  }

  function le(e) {
    return function (r) {
      if (!r.root) if (r = r.return) e(r);
    };
  }

  function ve(c, s, u, i) {
    if (!c.return) switch (c.type) {
      case t:
        c.return = ue(c.value, c.length);
        break;

      case p:
        return ie([I(y(c.value, "@", "@" + a), c, "")], i);

      case n:
        if (c.length) return S(c.props, function (n) {
          switch (x(n, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return ie([I(y(n, /:(read-\w+)/, ":" + r + "$1"), c, "")], i);

            case "::placeholder":
              return ie([I(y(n, /:(plac\w+)/, ":" + a + "input-$1"), c, ""), I(y(n, /:(plac\w+)/, ":" + r + "$1"), c, ""), I(y(n, /:(plac\w+)/, e + "input-$1"), c, "")], i);
          }

          return "";
        });
    }
  }

  function he(e) {
    switch (e.type) {
      case n:
        e.props = e.props.map(function (r) {
          return S(W(r), function (r, a, c) {
            switch (z(r, 0)) {
              case 12:
                return C(r, 1, A(r));

              case 0:
              case 40:
              case 43:
              case 62:
              case 126:
                return r;

              case 58:
                if (c[++a] === "global") c[a] = "", c[++a] = "\f" + C(c[a], a = 1, -1);

              case 32:
                return a === 1 ? "" : r;

              default:
                switch (a) {
                  case 0:
                    e = r;
                    return M(c) > 1 ? "" : r;

                  case a = M(c) - 1:
                  case 2:
                    return a === 2 ? r + e + e : r + e;

                  default:
                    return r;
                }

            }
          });
        });
    }
  }
  /***/

}
/******/
]);